import { render, staticRenderFns } from "./muck.vue?vue&type=template&id=8b7647fa"
import script from "./muck.vue?vue&type=script&lang=js"
export * from "./muck.vue?vue&type=script&lang=js"
import style0 from "./muck.vue?vue&type=style&index=0&id=8b7647fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports